import styled from 'styled-components';

export const LegendContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: start;
  margin-left: 25%;
  margin-top: 16px;
`;

export const LegendItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 15px !important;
`;

export const ColorBox = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background-color: ${(props) => props.color};
`;

export const SvgWrapper = styled.div`
  .segment {
    margin-top: 0px !important;
    padding: 0px !important;
  }
  .ui.attached.segment {
   height: 440px;
   padding: 0px !important;
   max-height: 440px;
  }
`